export const decimalRegex = /^-?\d+\.?\d*$/;
export const inputableDecimalRegex = /^(-|-?\d+\.?\d*)$/; // for 'NInputDecimal', type '-' is legal, expects rest numbers
export const inputableNumberRegex = /^-?[0-9]*$/;
export const inputableIdRegex = /^[0-9]*$/;
